import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initWebVitalsLogger } from './utils/webVitalsLogger'

// Boot logging to confirm JS bundle is executing
console.log('[YachtValues] App boot started', { timestamp: Date.now() });

// Initialize Web Vitals logging (non-blocking)
initWebVitalsLogger();

const rootElement = document.getElementById("root");

if (rootElement) {
  try {
    createRoot(rootElement).render(<App />);
    // Mark that React mounted successfully
    (window as any).__APP_MOUNTED__ = true;
    console.log('[YachtValues] App mounted successfully');
  } catch (error) {
    console.error('[YachtValues] Fatal error during mount:', error);
    // Show a basic error message if React fails to mount
    rootElement.innerHTML = `
      <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:system-ui;padding:2rem;text-align:center;">
        <div>
          <h1 style="color:#dc2626;margin-bottom:1rem;">Failed to load application</h1>
          <p style="color:#64748b;margin-bottom:1rem;">Please try refreshing the page.</p>
          <button onclick="location.reload()" style="padding:0.75rem 1.5rem;background:#1e40af;color:white;border:none;border-radius:8px;cursor:pointer;">
            Refresh
          </button>
          <pre style="margin-top:1rem;text-align:left;background:#1e293b;color:#e2e8f0;padding:1rem;border-radius:8px;font-size:0.75rem;overflow:auto;">${error}</pre>
        </div>
      </div>
    `;
  }
} else {
  console.error('[YachtValues] Root element not found');
}
